(function ($) {
    $(window).on('load', function () {
        if ($('.publications-slider').length > 0) {
            setTimeout(function () {
                $(".publications-slider .slider").css({"opacity": "1"});
            }, 500);
        }
        $("#publications .slider .col-wrap").unwrap().unwrap().unwrap().unwrap().unwrap();

        setTimeout(function () {
            if ($('.publications-slider .slider .col-wrap').length > 1) {
                $('.publications-slider .slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    infinite: true,
                    cssEase: 'linear',
                    autoplay: true,
                    autoplaySpeed: 2000,
                });
            }
        }, 200);
    });

})(jQuery);
